<template>
    <div class="requirements-list-area bg-gray" id="benefits">
        <div class="row align-items-center">
            <div class="col-lg-6 order-2">
                <div class="requirements-list">
                    <h2 class="requirements-list__title mb-15 wow move-up">Ihre Vorteile bei uns</h2>
                    <p class="requirements-list__text heading mb-30 wow move-up">
                      Als Kunstliebhaber können Sie Ihre Bibliotheksstruktur optimieren oder Ihre Sammlungen veräußern. Die Entscheidung liegt bei Ihnen.
                    </p>
                    <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                        <li class="list-item">Keine Vermittlungsgebühr</li>
                        <li class="list-item">Marktgerechte Angebote</li>
                        <li class="list-item">Über 100.000 Interessenten; darunter zertifizierte Kunsthändler</li>
                        <li class="list-item">Direkte Vermittlung</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 order-1">
                <div class="requirements-list-image wow move-up mx-auto">
                    <img src="../assets/img/features/business_deal.svg" class="img-fluid" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'requireList'
    }
</script>

<style>

</style>